import { z } from "zod";
import { EntitySchema, type Entity } from "./Entity";
import { v4 as uuidv4 } from "uuid";

export const ProjectEntitySchema = z.object({
  projectEntityId: z.string().nullable(),
  projectId: z.string(),
  drawNumber: z.number(),
  type: z.string(),
  entity: EntitySchema,
  ordinal: z.number(),
  defaultPayee: z.boolean(),
  initialFunds: z.number(),
  fundsAdjustment: z.number(),
  closingCosts: z.number(),
  principalReduction: z.number(),
  totalPrincipalReduction: z.number(),
  origTotalPrincipalReduction: z.number(),
  totalFundsAdjustment: z.number(),
  totalFundsAdjustmentV2: z.number(),
  netFunds: z.number(),
  fundsDisbursed: z.number(),
  totalFundsDisbursed: z.number(),
  origTotalFundsDisbursed: z.number(),
  targetTotalFunds: z.number(),
  balance: z.number(),
  totalFundsRetained: z.number(),
  origTotalFundsRetained: z.number(),
  participationPercent: z.number(),
  participationRank: z.number(),
  fundsDisbursedAdjustment: z.number(),
  newSource: z.boolean(),
  sendCompletionEmail: z.boolean(),
});

export const ProjectEntityListSchema = z.array(ProjectEntitySchema);

export type ProjectEntity = z.infer<typeof ProjectEntitySchema>;

export const createProjectEntity = (type: string, entity: Entity, ordinal: number, drawNumber: number, projectId: string): ProjectEntity => {
  return {
    projectEntityId: uuidv4(),
    projectId: projectId,
    drawNumber: drawNumber,
    type: type,
    entity: entity,
    ordinal: ordinal,
    defaultPayee: false,
    initialFunds: 0,
    fundsAdjustment: 0,
    closingCosts: 0,
    principalReduction: 0,
    totalPrincipalReduction: 0,
    origTotalPrincipalReduction: 0,
    totalFundsAdjustment: 0,
    totalFundsAdjustmentV2: 0,
    netFunds: 0,
    fundsDisbursed: 0,
    totalFundsDisbursed: 0,
    origTotalFundsDisbursed: 0,
    targetTotalFunds: 0,
    balance: 0,
    totalFundsRetained: 0,
    origTotalFundsRetained: 0,
    participationPercent: 0,
    participationRank: 0,
    fundsDisbursedAdjustment: 0,
    newSource: true,
    sendCompletionEmail: false,
  };
};
